exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.table[data-v-fd31e14a] {\n  width: 100%;\n  margin-top: 0.266667rem;\n  border-collapse: collapse;\n  border: 0.026667rem solid #000;\n  overflow-y: auto;\n}\n.table td[data-v-fd31e14a] {\n  border: 0.026667rem solid #000;\n  text-align: center;\n  min-width: 0.666667rem;\n}\n.table td .tab-2[data-v-fd31e14a] {\n  text-indent: 0 !important;\n}\n.table td a[data-v-fd31e14a] {\n  word-break: break-all;\n}", ""]);

// exports
